import store from "../controller/baseController";
import Enums from "../enums/enums";
import i18n from "../locales/i18n";

function GetMerchantPackageRightApplication(applicationRaw) {
  return {
    peakAccount: applicationRaw.peakAccount,
    oldPeakAccount: applicationRaw.oldPeakAccount,
    peakPayroll: applicationRaw.peakPayroll,
    peakAsset: applicationRaw.peakAsset,
    peakBoard: applicationRaw.peakBoard,
    peakTax: applicationRaw.peakTax,
    peakLineConnect: applicationRaw.peakLineConnect,
    peakMobile: applicationRaw.peakMobile,
    peakDocument: applicationRaw.peakDocument,
  };
}
function GetMerchantPackageRightPeakAccountApplicationRevenue(revenueRaw) {
  return {
    quotation: revenueRaw.quotation,
    invoice: revenueRaw.invoice,
    invoiceAsset: revenueRaw.invoiceAsset,
    receipt: revenueRaw.receipt,
    receiptAsset: revenueRaw.receiptAsset,
    taxInvoice: revenueRaw.taxInvoice,
    creditNote: revenueRaw.creditNote,
    billingNote: revenueRaw.billingNote,
    debitNote: revenueRaw.debitNote,
    recurringInvoice: revenueRaw.recurringInvoice,
    recurringReceipt: revenueRaw.recurringReceipt,
    deposit: revenueRaw.deposit,
  };
}
function GetMerchantPackageRightPeakAccountApplicationExpense(expenseRaw) {
  return {
    purchaseOrder: expenseRaw.purchaseOrder,
    purchaseOrderAsset: expenseRaw.purchaseOrderAsset,
    expense: expenseRaw.expense,
    purchaseAsset: expenseRaw.purchaseAsset,
    purchaseTaxInvoice: expenseRaw.purchaseTaxInvoice,
    receivedCreditNote: expenseRaw.receivedCreditNote,
    receivedDebitNote: expenseRaw.receivedDebitNote,
    combinePaymentNote: expenseRaw.combinePaymentNote,
    recurringExpense: expenseRaw.recurringExpense,
    receivedDeposit: expenseRaw.receivedDeposit,
    goodsReceipt: expenseRaw.goodsReceipt,
    invoiceReceipt: expenseRaw.invoiceReceipt,
    purchaseRequisition: expenseRaw.purchaseRequisition,
  };
}
function GetMerchantPackageRightPeakAccountApplicationFinance(financeRaw) {
  return {
    addFinance: financeRaw.addFinance,
    reconcile: financeRaw.reconcile,
    statement: financeRaw.statement,
    createTransactionFromStatement: financeRaw.createTransactionFromStatement,
    paymentFile: financeRaw.paymentFile,
  };
}
function GetMerchantPackageRightPeakAccountApplicationAccounts(accountRaw) {
  return {
    addAccount: accountRaw.addAccount,
    actionJournal: accountRaw.actionJournal,
    createProfitLossTemplate: accountRaw.createProfitLossTemplate,
    createBalanceSheetTemplate: accountRaw.createBalanceSheetTemplate,
    cashFlowStatement: accountRaw.cashFlowStatement,
  };
}
function GetMerchantPackageRightPeakAccountApplicationDocumentSetting(documentRaw) {
  return {
    cassification: documentRaw.cassification,
    redirectLinkReport: documentRaw.redirectLinkReport,
    taxInvoice: documentRaw.taxInvoice,
    journal: documentRaw.journal,
    uniqueTransactionNumber: documentRaw.uniqueTransactionNumber,
  };
}
function GetMerchantPackageRightPeakAccountApplicationUserSetting(userRaw) {
  return {
    userRoleContact: userRaw.userRoleContact,
  };
}
function GetMerchantPackageRightPeakAccountApplicationAccountingPolicySetting(accountingPolicyRaw) {
  return {
    summaryReport: accountingPolicyRaw.summaryReport,
    creditLimit: accountingPolicyRaw.creditLimit,
    inventorySystem: accountingPolicyRaw.inventorySystem,
    purchaseOrderStatusUpdate: accountingPolicyRaw.purchaseOrderStatusUpdate,
    invoiceAndGoodReceiptSettingDefaultAccountId: accountingPolicyRaw.invoiceAndGoodReceiptSettingDefaultAccountId,
  };
}
function GetMerchantPackageRightPeakAccountApplicationSetting(settingRaw) {
  return {
    user: GetMerchantPackageRightPeakAccountApplicationUserSetting(settingRaw.user),
    document: GetMerchantPackageRightPeakAccountApplicationDocumentSetting(settingRaw.document),
    accountingPolicy: GetMerchantPackageRightPeakAccountApplicationAccountingPolicySetting(settingRaw.accountingPolicy),
    applicationConnect: settingRaw.applicationConnect,
  };
}
function GetMerchantPackageRightPeakAccountApplication(accountRaw) {
  return {
    totalDocumentPerMonth: accountRaw.totalDocumentPerMonth,
    export: accountRaw.export,
    importProduct: accountRaw.importProduct,
    importContact: accountRaw.importContact,
    importTransaction: accountRaw.importTransaction,
    lot: accountRaw.lot,
    partailPayment: accountRaw.partailPayment,
    revenue: GetMerchantPackageRightPeakAccountApplicationRevenue(accountRaw.revenue),
    expense: GetMerchantPackageRightPeakAccountApplicationExpense(accountRaw.expense),
    finance: GetMerchantPackageRightPeakAccountApplicationFinance(accountRaw.finance),
    account: GetMerchantPackageRightPeakAccountApplicationAccounts(accountRaw.account),
    fileVault: accountRaw.fileVault,
    setting: GetMerchantPackageRightPeakAccountApplicationSetting(accountRaw.setting),
  };
}
function GetMerchantPackageRightPeakTaxApplication(taxRaw) {
  return { fetchDataFromPeakAccount: taxRaw.fetchDataFromPeakAccount };
}
function GetMerchantPackageRightPeakAssetApplication(assetRaw) {
  return { totalAsset: assetRaw.totalAsset };
}
function GetMerchantPackageRight(merchantPackageRightRaw) {
  if (merchantPackageRightRaw) {
    return {
      application: GetMerchantPackageRightApplication(merchantPackageRightRaw.application),
      account: GetMerchantPackageRightPeakAccountApplication(merchantPackageRightRaw.account),
      tax: GetMerchantPackageRightPeakTaxApplication(merchantPackageRightRaw.tax),
      asset: GetMerchantPackageRightPeakAssetApplication(merchantPackageRightRaw.asset),
      totalPaymentMethod: merchantPackageRightRaw.totalPaymentMethod,
    };
  } else {
    return {
      application: null,
      account: null,
      tax: null,
      asset: null,
      totalPaymentMethod: null,
    };
  }
}
function GetRole(userRoleRaw) {
  return {
    authorityRole: userRoleRaw.authorityRole,
    role: userRoleRaw.role,
    manageUser: userRoleRaw.manageUser,
    manageFinance: userRoleRaw.manageFinance,
    isSuperUser: userRoleRaw.isSuperUser,
    isUsePayroll: userRoleRaw.isUsePayroll,
    isUsePeakBoard: userRoleRaw.isUsePeakBoard,
    manageProduct: userRoleRaw.manageProduct,
    isSeeSelfDocuments: userRoleRaw.isSeeSelfDocuments,
    manageFinanceAndJournals: userRoleRaw.manageFinanceAndJournals,
    manageAsset: userRoleRaw.manageAsset,
    manageContact: userRoleRaw.manageContact,
    isViewReport: userRoleRaw.isViewReport,
    isDeactivate: userRoleRaw.isDeactivate,
  };
}
function GetSelectedMerchant(merchantRaw) {
  return {
    merchantId: merchantRaw.merchantId,
    businessCategoryId: merchantRaw.businessCategoryId,
    merchantName: merchantRaw.merchantName,
    merchantNameEng: merchantRaw.merchantNameEng,
    merchantNameTh: merchantRaw.merchantNameTh,
    merchantBranchCode: merchantRaw.merchantBranchCode,
    merchantTaxId: merchantRaw.merchantTaxId,
    code: merchantRaw.code,
    createDateTime: merchantRaw.createDateTime,
    isAccountingFirm: merchantRaw.isAccountingFirm,
    merchantType: merchantRaw.merchantType,
    taxStatus: merchantRaw.taxStatus,
    logoUrl: merchantRaw.logoUrl,
    stampUrl: merchantRaw.stampUrl,
    isSample: merchantRaw.isSample,
    isVat: merchantRaw.isVat,
    isActivePayroll: merchantRaw.isActivePayroll,
    isLockPeriod: merchantRaw.isLockPeriod,
    lockPeriodEndDate: merchantRaw.lockPeriodEndDate,
    joinMerchantDateTime: merchantRaw.joinMerchantDateTime,
    package: merchantRaw.package,
    expireDateTime: merchantRaw.expireDateTime,
    packageName: merchantRaw.packageName,
    merchantPackageRight: GetMerchantPackageRight(merchantRaw.merchantPackageRight),
    role: GetRole(merchantRaw.role),
  };
}
export const RoleCannotApprovedDocument = (baseRole) => {
  return (
    baseRole == Enums.UserRight.ViewOnly ||
    baseRole == Enums.UserRight.RevenueDraftOnly ||
    baseRole == Enums.UserRight.ExpenseDraftOnly ||
    baseRole == Enums.UserRight.RevenueExpenseDraftOnly ||
    baseRole == Enums.UserRight.QuotationDraftOnly ||
    baseRole == Enums.UserRight.PurchaseOrderDraftOnly
  );
};
export const RoleCanApprovedAllDocument = (baseRole) => {
  return (
    baseRole == Enums.UserRight.Standard ||
    baseRole == Enums.UserRight.BasicAndAdmin ||
    baseRole == Enums.UserRight.RevenueExpenseApproveOnly
  );
};
export const RoleCanApprovedRevenueAll = (baseRole) => {
  return (
    baseRole == Enums.UserRight.RevenueAll ||
    baseRole == Enums.UserRight.CreateRevenueOnly ||
    baseRole == Enums.UserRight.RevenueApproveOnly
  );
};
export const RoleCanApprovedExpenseAll = (baseRole) => {
  return (
    baseRole == Enums.UserRight.ExpenseAll ||
    baseRole == Enums.UserRight.CreateExpenseOnly ||
    baseRole == Enums.UserRight.ExpenseApproveOnly
  );
};

export const IsApprovedPurchaseRequisitionBase = (baseRole) => {
  switch (baseRole) {
    case Enums.UserRight.QuotationOnly:
      return true;
    case Enums.UserRight.QuotationApproveOnly:
      return true;
    case Enums.UserRight.PurchaseOrderApproveOnly:
      return false;
    case Enums.UserRight.PurchaseOrderOnly:
      return false;
    case Enums.UserRight.ExpenseExceptPOAll:
      return false;
    case Enums.UserRight.RevenueExceptQOAll:
      return false;
    case Enums.UserRight.RevenueExpenseExceptQOandPOApproveOnly:
      return false;
  }
};
export const IsApprovedQuotationBase = (baseRole) => {
  switch (baseRole) {
    case Enums.UserRight.QuotationOnly:
      return true;
    case Enums.UserRight.QuotationApproveOnly:
      return true;
    case Enums.UserRight.PurchaseOrderApproveOnly:
      return false;
    case Enums.UserRight.PurchaseOrderOnly:
      return false;
    case Enums.UserRight.ExpenseExceptPOAll:
      return false;
    case Enums.UserRight.RevenueExceptQOAll:
      return false;
    case Enums.UserRight.RevenueExpenseExceptQOandPOApproveOnly:
      return false;
  }
};

export const IsApprovedPurchaseRequisition = (baseRole) => {
  if (RoleCannotApprovedDocument(baseRole)) {
    return false;
  } else if (RoleCanApprovedAllDocument(baseRole)) {
    return true;
  } else if (RoleCanApprovedRevenueAll(baseRole)) {
    return true;
  } else if (RoleCanApprovedExpenseAll(baseRole)) {
    return false;
  } else {
    return IsApprovedPurchaseRequisitionBase(baseRole);
  }
};
export const IsApprovedQuotation = (baseRole) => {
  if (RoleCannotApprovedDocument(baseRole)) {
    return false;
  } else if (RoleCanApprovedAllDocument(baseRole)) {
    return true;
  } else if (RoleCanApprovedRevenueAll(baseRole)) {
    return true;
  } else if (RoleCanApprovedExpenseAll(baseRole)) {
    return false;
  } else {
    return IsApprovedQuotationBase(baseRole);
  }
};
export const IsApprovedInvoiceBase = (baseRole) => {
  switch (baseRole) {
    case Enums.UserRight.QuotationOnly:
      return false;
    case Enums.UserRight.PurchaseOrderOnly:
      return false;
    case Enums.UserRight.QuotationApproveOnly:
      return false;
    case Enums.UserRight.PurchaseOrderApproveOnly:
      return false;
    case Enums.UserRight.ExpenseExceptPOAll:
      return false;
    case Enums.UserRight.RevenueExceptQOAll:
      return true;
    case Enums.UserRight.RevenueExpenseExceptQOandPOApproveOnly:
      return true;
  }
};
export const IsApprovedInvoice = (baseRole) => {
  if (RoleCannotApprovedDocument(baseRole)) {
    return false;
  } else if (RoleCanApprovedAllDocument(baseRole)) {
    return true;
  } else if (RoleCanApprovedRevenueAll(baseRole)) {
    return true;
  } else if (RoleCanApprovedExpenseAll(baseRole)) {
    return false;
  } else {
    return IsApprovedInvoiceBase(baseRole);
  }
};
export const IsApprovedRecieptBase = (baseRole) => {
  switch (baseRole) {
    case Enums.UserRight.QuotationOnly:
      return false;
    case Enums.UserRight.PurchaseOrderOnly:
      return false;
    case Enums.UserRight.QuotationApproveOnly:
      return false;
    case Enums.UserRight.PurchaseOrderApproveOnly:
      return false;
    case Enums.UserRight.ExpenseExceptPOAll:
      return false;
    case Enums.UserRight.RevenueExceptQOAll:
      return true;
    case Enums.UserRight.RevenueExpenseExceptQOandPOApproveOnly:
      return true;
  }
};
export const IsApprovedReciept = (baseRole) => {
  if (RoleCannotApprovedDocument(baseRole)) {
    return false;
  } else if (RoleCanApprovedAllDocument(baseRole)) {
    return true;
  } else if (RoleCanApprovedRevenueAll(baseRole)) {
    return true;
  } else if (RoleCanApprovedExpenseAll(baseRole)) {
    return false;
  } else {
    return IsApprovedRecieptBase(baseRole);
  }
};
export const IsApprovedSaleTaxInvoiceBase = (baseRole) => {
  switch (baseRole) {
    case Enums.UserRight.QuotationOnly:
      return false;
    case Enums.UserRight.PurchaseOrderOnly:
      return false;
    case Enums.UserRight.QuotationApproveOnly:
      return false;
    case Enums.UserRight.PurchaseOrderApproveOnly:
      return false;
    case Enums.UserRight.ExpenseExceptPOAll:
      return false;
    case Enums.UserRight.RevenueExceptQOAll:
      return true;
    case Enums.UserRight.RevenueExpenseExceptQOandPOApproveOnly:
      return true;
  }
};
export const IsApprovedSaleTaxInvoice = (baseRole) => {
  if (RoleCannotApprovedDocument(baseRole)) {
    return false;
  } else if (RoleCanApprovedAllDocument(baseRole)) {
    return true;
  } else if (RoleCanApprovedRevenueAll(baseRole)) {
    return true;
  } else if (RoleCanApprovedExpenseAll(baseRole)) {
    return false;
  } else {
    return IsApprovedSaleTaxInvoiceBase(baseRole);
  }
};
export const IsApprovedCreditNoteBase = (baseRole) => {
  switch (baseRole) {
    case Enums.UserRight.QuotationOnly:
      return false;
    case Enums.UserRight.PurchaseOrderOnly:
      return false;
    case Enums.UserRight.QuotationApproveOnly:
      return false;
    case Enums.UserRight.PurchaseOrderApproveOnly:
      return false;
    case Enums.UserRight.ExpenseExceptPOAll:
      return false;
    case Enums.UserRight.RevenueExceptQOAll:
      return true;
    case Enums.UserRight.RevenueExpenseExceptQOandPOApproveOnly:
      return true;
  }
};
export const IsApprovedCreditNote = (baseRole) => {
  if (RoleCannotApprovedDocument(baseRole)) {
    return false;
  } else if (RoleCanApprovedAllDocument(baseRole)) {
    return true;
  } else if (RoleCanApprovedRevenueAll(baseRole)) {
    return true;
  } else if (RoleCanApprovedExpenseAll(baseRole)) {
    return false;
  } else {
    return IsApprovedCreditNoteBase(baseRole);
  }
};
export const IsApprovedDebitNoteBase = (baseRole) => {
  switch (baseRole) {
    case Enums.UserRight.QuotationOnly:
      return false;
    case Enums.UserRight.PurchaseOrderOnly:
      return false;
    case Enums.UserRight.QuotationApproveOnly:
      return false;
    case Enums.UserRight.PurchaseOrderApproveOnly:
      return false;
    case Enums.UserRight.ExpenseExceptPOAll:
      return false;
    case Enums.UserRight.RevenueExceptQOAll:
      return true;
    case Enums.UserRight.RevenueExpenseExceptQOandPOApproveOnly:
      return true;
  }
};
export const IsApprovedDebitNote = (baseRole) => {
  if (RoleCannotApprovedDocument(baseRole)) {
    return false;
  } else if (RoleCanApprovedAllDocument(baseRole)) {
    return true;
  } else if (RoleCanApprovedRevenueAll(baseRole)) {
    return true;
  } else if (RoleCanApprovedExpenseAll(baseRole)) {
    return false;
  } else {
    return IsApprovedDebitNoteBase(baseRole);
  }
};
export const IsApprovedBillingNoteBase = (baseRole) => {
  switch (baseRole) {
    case Enums.UserRight.QuotationOnly:
      return false;
    case Enums.UserRight.PurchaseOrderOnly:
      return false;
    case Enums.UserRight.QuotationApproveOnly:
      return false;
    case Enums.UserRight.PurchaseOrderApproveOnly:
      return false;
    case Enums.UserRight.ExpenseExceptPOAll:
      return false;
    case Enums.UserRight.RevenueExceptQOAll:
      return true;
    case Enums.UserRight.RevenueExpenseExceptQOandPOApproveOnly:
      return true;
  }
};
export const IsApprovedBillingNote = (baseRole) => {
  if (RoleCannotApprovedDocument(baseRole)) {
    return false;
  } else if (RoleCanApprovedAllDocument(baseRole)) {
    return true;
  } else if (RoleCanApprovedRevenueAll(baseRole)) {
    return true;
  } else if (RoleCanApprovedExpenseAll(baseRole)) {
    return false;
  } else {
    return IsApprovedBillingNoteBase(baseRole);
  }
};
export const IsApprovedDepositRecieptBase = (baseRole) => {
  switch (baseRole) {
    case Enums.UserRight.QuotationOnly:
      return false;
    case Enums.UserRight.PurchaseOrderOnly:
      return false;
    case Enums.UserRight.QuotationApproveOnly:
      return false;
    case Enums.UserRight.PurchaseOrderApproveOnly:
      return false;
    case Enums.UserRight.ExpenseExceptPOAll:
      return false;
    case Enums.UserRight.RevenueExceptQOAll:
      return true;
    case Enums.UserRight.RevenueExpenseExceptQOandPOApproveOnly:
      return true;
  }
};
export const IsApprovedDepositReciept = (baseRole) => {
  if (RoleCannotApprovedDocument(baseRole)) {
    return false;
  } else if (RoleCanApprovedAllDocument(baseRole)) {
    return true;
  } else if (RoleCanApprovedRevenueAll(baseRole)) {
    return true;
  } else if (RoleCanApprovedExpenseAll(baseRole)) {
    return false;
  } else {
    return IsApprovedDepositRecieptBase(baseRole);
  }
};
export const IsApprovedPOBase = (baseRole) => {
  switch (baseRole) {
    case Enums.UserRight.QuotationOnly:
      return false;
    case Enums.UserRight.PurchaseOrderOnly:
      return true;
    case Enums.UserRight.QuotationApproveOnly:
      return false;
    case Enums.UserRight.PurchaseOrderApproveOnly:
      return true;
    case Enums.UserRight.ExpenseExceptPOAll:
      return false;
    case Enums.UserRight.RevenueExceptQOAll:
      return false;
    case Enums.UserRight.RevenueExpenseExceptQOandPOApproveOnly:
      return false;
  }
};
export const IsApprovedPO = (baseRole) => {
  if (RoleCannotApprovedDocument(baseRole)) {
    return false;
  } else if (RoleCanApprovedAllDocument(baseRole)) {
    return true;
  } else if (RoleCanApprovedRevenueAll(baseRole)) {
    return false;
  } else if (RoleCanApprovedExpenseAll(baseRole)) {
    return true;
  } else {
    return IsApprovedPOBase(baseRole);
  }
};
export const IsApprovedExpenseBase = (baseRole) => {
  switch (baseRole) {
    case Enums.UserRight.QuotationOnly:
      return false;
    case Enums.UserRight.PurchaseOrderOnly:
      return false;
    case Enums.UserRight.QuotationApproveOnly:
      return false;
    case Enums.UserRight.PurchaseOrderApproveOnly:
      return false;
    case Enums.UserRight.ExpenseExceptPOAll:
      return true;
    case Enums.UserRight.RevenueExceptQOAll:
      return false;
    case Enums.UserRight.RevenueExpenseExceptQOandPOApproveOnly:
      return true;
  }
};
export const IsApprovedExpense = (baseRole) => {
  if (RoleCannotApprovedDocument(baseRole)) {
    return false;
  } else if (RoleCanApprovedAllDocument(baseRole)) {
    return true;
  } else if (RoleCanApprovedRevenueAll(baseRole)) {
    return false;
  } else if (RoleCanApprovedExpenseAll(baseRole)) {
    return true;
  } else {
    return IsApprovedExpenseBase(baseRole);
  }
};
export const IsApprovedDepositPaymentBase = (baseRole) => {
  switch (baseRole) {
    case Enums.UserRight.QuotationOnly:
      return false;
    case Enums.UserRight.PurchaseOrderOnly:
      return false;
    case Enums.UserRight.QuotationApproveOnly:
      return false;
    case Enums.UserRight.PurchaseOrderApproveOnly:
      return false;
    case Enums.UserRight.ExpenseExceptPOAll:
      return true;
    case Enums.UserRight.RevenueExceptQOAll:
      return false;
    case Enums.UserRight.RevenueExpenseExceptQOandPOApproveOnly:
      return true;
  }
};
export const IsApprovedDepositPayment = (baseRole) => {
  if (RoleCannotApprovedDocument(baseRole)) {
    return false;
  } else if (RoleCanApprovedAllDocument(baseRole)) {
    return true;
  } else if (RoleCanApprovedRevenueAll(baseRole)) {
    return false;
  } else if (RoleCanApprovedExpenseAll(baseRole)) {
    return true;
  } else {
    return IsApprovedDepositPaymentBase(baseRole);
  }
};
export const IsApprovedGoodsReceiptBase = (baseRole) => {
  switch (baseRole) {
    case Enums.UserRight.QuotationOnly:
      return false;
    case Enums.UserRight.PurchaseOrderOnly:
      return false;
    case Enums.UserRight.QuotationApproveOnly:
      return false;
    case Enums.UserRight.PurchaseOrderApproveOnly:
      return false;
    case Enums.UserRight.ExpenseExceptPOAll:
      return true;
    case Enums.UserRight.RevenueExceptQOAll:
      return false;
    case Enums.UserRight.RevenueExpenseExceptQOandPOApproveOnly:
      return true;
  }
};
export const IsApprovedGoodsReceipt = (baseRole) => {
  if (RoleCannotApprovedDocument(baseRole)) {
    return false;
  } else if (RoleCanApprovedAllDocument(baseRole)) {
    return true;
  } else if (RoleCanApprovedRevenueAll(baseRole)) {
    return false;
  } else if (RoleCanApprovedExpenseAll(baseRole)) {
    return true;
  } else {
    return IsApprovedGoodsReceiptBase(baseRole);
  }
};
export const IsApprovedInvoiceReceiptBase = (baseRole) => {
  switch (baseRole) {
    case Enums.UserRight.QuotationOnly:
      return false;
    case Enums.UserRight.PurchaseOrderOnly:
      return false;
    case Enums.UserRight.QuotationApproveOnly:
      return false;
    case Enums.UserRight.PurchaseOrderApproveOnly:
      return false;
    case Enums.UserRight.ExpenseExceptPOAll:
      return true;
    case Enums.UserRight.RevenueExceptQOAll:
      return false;
    case Enums.UserRight.RevenueExpenseExceptQOandPOApproveOnly:
      return true;
  }
};
export const IsApprovedInvoiceReceipt = (baseRole) => {
  if (RoleCannotApprovedDocument(baseRole)) {
    return false;
  } else if (RoleCanApprovedAllDocument(baseRole)) {
    return true;
  } else if (RoleCanApprovedRevenueAll(baseRole)) {
    return false;
  } else if (RoleCanApprovedExpenseAll(baseRole)) {
    return true;
  } else {
    return IsApprovedInvoiceReceiptBase(baseRole);
  }
};
export const IsApprovedReceiveCreditNoteBase = (baseRole) => {
  switch (baseRole) {
    case Enums.UserRight.QuotationOnly:
      return false;
    case Enums.UserRight.PurchaseOrderOnly:
      return false;
    case Enums.UserRight.QuotationApproveOnly:
      return false;
    case Enums.UserRight.PurchaseOrderApproveOnly:
      return false;
    case Enums.UserRight.ExpenseExceptPOAll:
      return true;
    case Enums.UserRight.RevenueExceptQOAll:
      return false;
    case Enums.UserRight.RevenueExpenseExceptQOandPOApproveOnly:
      return true;
  }
};
export const IsApprovedReceiveCreditNote = (baseRole) => {
  if (RoleCannotApprovedDocument(baseRole)) {
    return false;
  } else if (RoleCanApprovedAllDocument(baseRole)) {
    return true;
  } else if (RoleCanApprovedRevenueAll(baseRole)) {
    return false;
  } else if (RoleCanApprovedExpenseAll(baseRole)) {
    return true;
  } else {
    return IsApprovedReceiveCreditNoteBase(baseRole);
  }
};
export const IsApprovedReceiveDebitNoteBase = (baseRole) => {
  switch (baseRole) {
    case Enums.UserRight.QuotationOnly:
      return false;
    case Enums.UserRight.PurchaseOrderOnly:
      return false;
    case Enums.UserRight.QuotationApproveOnly:
      return false;
    case Enums.UserRight.PurchaseOrderApproveOnly:
      return false;
    case Enums.UserRight.ExpenseExceptPOAll:
      return true;
    case Enums.UserRight.RevenueExceptQOAll:
      return false;
    case Enums.UserRight.RevenueExpenseExceptQOandPOApproveOnly:
      return true;
  }
};
export const IsApprovedReceiveDebitNote = (baseRole) => {
  if (RoleCannotApprovedDocument(baseRole)) {
    return false;
  } else if (RoleCanApprovedAllDocument(baseRole)) {
    return true;
  } else if (RoleCanApprovedRevenueAll(baseRole)) {
    return false;
  } else if (RoleCanApprovedExpenseAll(baseRole)) {
    return true;
  } else {
    return IsApprovedReceiveDebitNoteBase(baseRole);
  }
};
export const IsApprovedCombinedPaymentNoteBase = (baseRole) => {
  switch (baseRole) {
    case Enums.UserRight.QuotationOnly:
      return false;
    case Enums.UserRight.PurchaseOrderOnly:
      return false;
    case Enums.UserRight.QuotationApproveOnly:
      return false;
    case Enums.UserRight.PurchaseOrderApproveOnly:
      return false;
    case Enums.UserRight.ExpenseExceptPOAll:
      return true;
    case Enums.UserRight.RevenueExceptQOAll:
      return false;
    case Enums.UserRight.RevenueExpenseExceptQOandPOApproveOnly:
      return true;
  }
};
export const IsApprovedCombinedPaymentNote = (baseRole) => {
  if (RoleCannotApprovedDocument(baseRole)) {
    return false;
  } else if (RoleCanApprovedAllDocument(baseRole)) {
    return true;
  } else if (RoleCanApprovedRevenueAll(baseRole)) {
    return false;
  } else if (RoleCanApprovedExpenseAll(baseRole)) {
    return true;
  } else {
    return IsApprovedCombinedPaymentNoteBase(baseRole);
  }
};
export const GetUserRight = (role1, role3, role4) => {
  if (role1 == 2 && role3 == 0 && role4 == 0) {
    return Enums.UserRight.ViewOnly;
  } else if (role1 == 3 && role3 == 0 && role4 == 0) {
    return Enums.UserRight.RevenueExpenseDraftOnly;
  } else if (role1 == 4 && role3 == 0 && role4 == 0) {
    return Enums.UserRight.RevenueExpenseApproveOnly;
  } else if (role1 == 5 && role3 == 0 && role4 == 0) {
    return Enums.UserRight.RevenueAll;
  } else if (role1 == 6 && role3 == 0 && role4 == 0) {
    return Enums.UserRight.ExpenseAll;
  } else if (role1 == 7 && role3 == 0 && role4 == 0) {
    return Enums.UserRight.QuotationOnly;
  } else if (role1 == 8 && role3 == 0 && role4 == 0) {
    return Enums.UserRight.CreateRevenueOnly;
  } else if (role1 == 9 && role3 == 0 && role4 == 0) {
    return Enums.UserRight.CreateExpenseOnly;
  } else if (role1 == 10 && role3 == 0 && role4 == 0) {
    return Enums.UserRight.PurchaseOrderOnly;
  } else if (role1 == 11 && role3 == 0 && role4 == 0) {
    return Enums.UserRight.RevenueDraftOnly;
  } else if (role1 == 12 && role3 == 0 && role4 == 0) {
    return Enums.UserRight.ExpenseDraftOnly;
  } else if (role1 == 13 && role3 == 0 && role4 == 0) {
    return Enums.UserRight.RevenueApproveOnly;
  } else if (role1 == 14 && role3 == 0 && role4 == 0) {
    return Enums.UserRight.ExpenseApproveOnly;
  } else if (role1 == 15 && role3 == 0 && role4 == 0) {
    return Enums.UserRight.QuotationDraftOnly;
  } else if (role1 == 16 && role3 == 0 && role4 == 0) {
    return Enums.UserRight.QuotationApproveOnly;
  } else if (role1 == 17 && role3 == 0 && role4 == 0) {
    return Enums.UserRight.PurchaseOrderDraftOnly;
  } else if (role1 == 18 && role3 == 0 && role4 == 0) {
    return Enums.UserRight.PurchaseOrderApproveOnly;
  } else if (role1 == 19 && role3 == 0 && role4 == 0) {
    return Enums.UserRight.ExpenseExceptPOAll;
  } else if (role1 == 20 && role3 == 0 && role4 == 0) {
    return Enums.UserRight.RevenueExceptQOAll;
  } else if (role1 == 21 && role3 == 0 && role4 == 0) {
    return Enums.UserRight.RevenueExpenseExceptQOandPOApproveOnly;
  } else if (role1 == 1 && role3 == 1 && role4 == 0) {
    return Enums.UserRight.Standard;
  } else if (role1 == 1 && role3 == 1 && role4 == 1) {
    return Enums.UserRight.BasicAndAdmin;
  } else {
    return Enums.UserRight.None;
  }
};
export default {
  GetSelectedMerchant(merchant) {
    return GetSelectedMerchant(merchant);
  },
  ConvertToUserModel(userInfo) {
    /* eslint-disable @typescript-eslint/camelcase */
    const userModel = {
      userId: userInfo.id,
      displayName: userInfo.given_name,
      lastLogInDateTime: userInfo.lastLogInDateTime,
      registerDateTime: userInfo.registerDateTime,
      phone: userInfo.phone_number,
      pictureUrl: userInfo.picture,
      signatureUrl: userInfo.signatureUrl,
      userEmail: userInfo.userEmail,
      firstName: userInfo.firstName,
      lastName: userInfo.lastName,
      birthdate: userInfo.birthdate,
      departmentId: userInfo.departmentId,
      departmentOther: userInfo.departmentOther,
      positionId: userInfo.positionId,
      positionOther: userInfo.positionOther,
      accountingFirmId: userInfo.accountingFirmId,
      userName: userInfo.userName,
      emailVerificationStatus: userInfo.emailVerificationStatus,
    };

    return userModel;
  },
  IsMerchantAFP() {
    const currentMerchant = store.getters.GetMerchant;
    return currentMerchant.isAccountingFirm;
  },
  CheckMerchantPackage(validPackageList) {
    const currentMerchant = store.getters.GetMerchant;
    const packageId = currentMerchant.package;
    if (validPackageList.includes(packageId)) {
      return true;
    }
    return false;
  },
  GetmerchantPackageRight() {
    const merchant = store.getters.GetMerchant;
    const merchantPackageRight = merchant.merchantPackageRight;
    return merchantPackageRight;
  },
  CheckMerchantAFPPackage() {
    return this.CheckMerchantPackage([Enums.Package.AFPFree, Enums.Package.AFPLedger, Enums.Package.AFPAccountant]);
  },
  GetBusinessType() {
    const typeId = store.getters.GetContactDetail.merchantType;
    let typeName = "-";
    switch (typeId) {
      case 1:
        typeName = i18n.t("Limited_Partnership");
        break;
      case 2:
        typeName = i18n.t("Company_Limited");
        break;
      case 3:
        typeName = i18n.t("Public_Company_Limited");
        break;
      case 4:
        typeName = i18n.t("Shop");
        break;
      case 5:
        typeName = i18n.t("Human");
        break;
      case 6:
        typeName = i18n.t("Body_of_Persons");
        break;
      case 7:
        typeName = i18n.t("Others");
        break;
      case 8:
        typeName = i18n.t("Ordinary_Partnership");
        break;
      case 9:
        typeName = i18n.t("Foundation");
        break;
      case 10:
        typeName = i18n.t("Association");
        break;
      case 11:
        typeName = i18n.t("Joint_Venture");
        break;
    }
    return typeName;
  },
  GetUserTemplate(userModel) {
    const userTemplate = {
      id: userModel.userId,
      pictureImg: {
        croppa: {},
        fileName: "",
        fileType: "",
        rawString: "",
        urlImg: userModel.pictureUrl,
      },
      isUpdatePictureImg: false,
      signatureImg: {
        croppa: {},
        fileName: "",
        fileType: "",
        rawString: "",
        urlImg: userModel.signatureUrl,
      },
      isUpdateSignatureImg: false,
      firstName: {
        value: userModel.firstName,
        validateError: false,
      },
      lastName: {
        value: userModel.lastName,
        validateError: false,
      },
      phone: {
        value: userModel.phone,
        validateError: false,
      },
      userEmail: {
        value: userModel.userEmail,
        validateError: false,
      },
      birthdate: {
        value: userModel.birthdate,
        validateError: false,
      },
      department: {
        value: { value: userModel.departmentId !== null ? userModel.departmentId : -1 },
        validateError: false,
      },
      departmentOther: {
        value: userModel.departmentOther ? userModel.departmentOther : "",
        validateError: false,
      },
      position: {
        value: { value: userModel.positionId !== null ? userModel.positionId : -1 },
        validateError: false,
      },
      positionOther: {
        value: userModel.positionOther ? userModel.positionOther : "",
        validateError: false,
      },
    };
    return userTemplate;
  },

  async checkUserIsSendApprove(userroleDetail, transactionType, financeType) {
    let baseRole = await GetUserRight(
      userroleDetail.userRoleModel.role1,
      userroleDetail.userRoleModel.role3,
      userroleDetail.userRoleModel.role4
    );
    if (financeType == Enums.FinanceType.InFlow) {
      switch (transactionType) {
        case Enums.TransactionType.Quotation:
          return IsApprovedQuotation(baseRole);
        case Enums.TransactionType.Invoice:
          return IsApprovedInvoice(baseRole);
        case Enums.TransactionType.Receipt:
          return IsApprovedReciept(baseRole);
        case Enums.TransactionType.TaxInvoice:
          return IsApprovedSaleTaxInvoice(baseRole);
        case Enums.TransactionType.CreditNote:
          return IsApprovedCreditNote(baseRole);
        case Enums.TransactionType.DebitNote:
          return IsApprovedDebitNote(baseRole);
        case Enums.TransactionType.BillingNote:
          return IsApprovedBillingNote(baseRole);
        case Enums.TransactionType.Deposit:
          return IsApprovedDepositReciept(baseRole);
      }
    } else {
      switch (transactionType) {
        case Enums.TransactionType.Quotation:
          return IsApprovedPO(baseRole);
        case Enums.TransactionType.Invoice:
          return IsApprovedExpense(baseRole);
        case Enums.TransactionType.TaxInvoice:
          return IsApprovedSaleTaxInvoice(baseRole);
        case Enums.TransactionType.CreditNote:
          return IsApprovedReceiveCreditNote(baseRole);
        case Enums.TransactionType.DebitNote:
          return IsApprovedReceiveDebitNote(baseRole);
        case Enums.TransactionType.BillingNote:
          return IsApprovedCombinedPaymentNote(baseRole);
        case Enums.TransactionType.Deposit:
          return IsApprovedDepositPayment(baseRole);
        case Enums.TransactionType.GoodsReceipt:
          return IsApprovedGoodsReceipt(baseRole);
        case Enums.TransactionType.InvoiceReceipt:
          return IsApprovedInvoiceReceipt(baseRole);
        case Enums.TransactionType.PurchaseRequisition:
          return IsApprovedPurchaseRequisition(baseRole);
      }
    }
  },
};
